import { Box3, Object3D } from "three";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Füllung } from "../arrangement/Füllung";
import * as Scenes from "oc-threejs/Scenes";
import { AbstractPart3d } from "./AbstractPart3d";
import { v3 } from "oc-threejs/short3";
import { createFakeLightPlanes, FakeLightPlaneProps } from "oc-scene-editor/utils/FakeLight3d";
import { MModelMaterialRelation } from "../../metamodell";
import type { ModelGhost } from "oc-jaco3d/arrangement/ModelGhost";
import { MyModel } from "../arrangement/MyModel";

export class Füllung3d extends AbstractPart3d {
  CLASS_NAME = "Füllung3d";
  declare jaco: Füllung;
  fakeLights: Object3D[] = [];

  constructor(jaco: Jaco) {
    super(jaco);
    this.tapable = false;
  }

  update3d() {
    super.update3d();
    if (
      this.changed("hasLichtleiste") ||
      this.changed("profilAuswahlwert", (f) => (f as Füllung).element?.profilAuswahlwert?.Key) ||
      this.changed("breite", (f) => (f as Füllung).element.breite)
    ) {
      this.updateFakeLight();
    }
  }

  getLichtleisteModell() {
    return this.jaco.modelle.find((m: ModelGhost) =>
      m.model.modelMaterialRelation.Model.Key.match(/licht/i)
    ) as ModelGhost;
  }

  updateFakeLight() {
    this.fakeLights.forEach((f) => Scenes.remove(f));
    this.fakeLights = [];
    if (this.jaco.hasLichtleiste) {
      this.addFakeLight();
    }
  }

  addFakeLight(): void {
    const lichtleiste = this.getLichtleisteModell();
    if (lichtleiste?.model) {
      const mmr = lichtleiste.model.modelMaterialRelation;
      const sizeCutted = (lichtleiste.model as MyModel).getSizeCutted();
      const box = new Box3().setFromCenterAndSize(v3(sizeCutted.x / 2, 0, 0), sizeCutted);
      addFakeLightFromMMR(this.fakeLights, lichtleiste, box, mmr);
    }
  }

  updateNightMode() {
    this.fakeLights.forEach((c) => {
      c.visible = APP.nightMode;
    });
  }

  clone(recursive?: boolean) {
    return new Füllung3d(this.jaco) as this;
  }
}

export function addFakeLightFromMMR(
  fakeLights: Object3D[],
  modelGhost: ModelGhost,
  box: Box3,
  mmr: MModelMaterialRelation
) {
  if (modelGhost?.jaco3d == null) {
    console.warn("Kann kein FakeLight hinzufügen, da modelGhost?.jaco3d == null");
    return;
  }

  const modelLight = mmr?.ModelLight;
  const fakeLightOptions = modelLight?.Json as FakeLightPlaneProps;

  if (fakeLightOptions == null) {
    console.warn(
      "Kann kein FakeLight hinzufügen, da kein ModelLight zugeordnet ist zur ModelMaterialRelation mit id " +
        mmr?.id +
        " für Model " +
        mmr?.Model?.Key
    );
    debugger;
    return;
  }

  const planes = createFakeLightPlanes(box as any, fakeLightOptions);
  planes.forEach((fakeLight) => {
    modelGhost.jaco3d.add(fakeLight);
    fakeLights.push(fakeLight);
  });
}
